import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { AlertApi } from '../../model/alerts/alert-api.model';
import { AlertRequestApi } from '../../model/alerts/alert-request-api.model';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({ providedIn: 'root' })
export class ApiAlertsService {
  constructor(private _requestService: RequestService) {}

  public fetchActiveAlerts(): Observable<RequestResponse<Array<AlertApi>>> {
    return this._requestService.get(ApiDirectory.Notificaciones.ListadoAlertasActivas({}), {
      loading: LoadingIds.FETCH_ALERTS,
    });
  }

  public removeAlert(idAlerta: number): Observable<RequestResponse<boolean>> {
    return this._requestService.put(ApiDirectory.Notificaciones.DesactivarAlerta({ idAlerta: idAlerta }), {});
  }

  public getAlertRequest(idAlerta: number): Observable<RequestResponse<AlertApi>> {
    return this._requestService.get(ApiDirectory.Notificaciones.DetalleAlerta({ idAlerta: idAlerta }));
  }

  public createAlert(alertRequest: AlertRequestApi): Observable<RequestResponse<boolean>> {
    return this._requestService.post(ApiDirectory.Notificaciones.CrearAlerta({}), alertRequest);
  }

  public updateAlert(idAlerta: number, alertRequest: AlertRequestApi): Observable<RequestResponse<boolean>> {
    return this._requestService.put(ApiDirectory.Notificaciones.ModificarAlerta({ idAlerta: idAlerta }), alertRequest);
  }
}
